function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from 'react';
import classnames from 'classnames';
import MembershipCardInfo from './MembershipCardInfo';
import { isMembershipPriceId } from '../../../utilities/membership';
var MembershipCard = function(props) {
    var priceId = props.priceId, info = props.info;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('MembershipCard', {
            noMembership: !isMembershipPriceId(priceId)
        })
    }, info === null || info === void 0 ? void 0 : info.map(function(infoData, i) {
        return /*#__PURE__*/ React.createElement(MembershipCardInfo, _object_spread({
            key: i
        }, infoData));
    }));
};
export default MembershipCard;
